
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-management",
      function () {
        return require("private-next-pages/company-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-management"])
      });
    }
  